/**
 * MetricCard - Reusable analytics metric card component
 */
import React from 'react';

export function MetricCard({ icon: Icon, iconColor, title, value, subtitle, subtitleColor }) {
  return (
    <div className="bg-white dark:bg-transparent backdrop-blur-md border border-gray-200 dark:border-gray-700 rounded-lg p-4">
      <div className="flex items-center">
        <div className={`p-2 ${iconColor} rounded-lg mr-3`}>
          <Icon className={`h-5 w-5 ${iconColor.replace('bg-', 'text-').replace('-100', '-600').replace('-900/20', '-400')}`} />
        </div>
        <div className="min-w-0 flex-1">
          <p className="text-sm text-gray-600 dark:text-gray-400">{title}</p>
          <p className="text-2xl font-bold text-gray-900 dark:text-white">{value}</p>
          {subtitle && (
            <p className={`text-xs ${subtitleColor || 'text-gray-500 dark:text-gray-400'}`}>
              {subtitle}
            </p>
          )}
        </div>
      </div>
    </div>
  );
}

export function MetricSection({ title, children, className = '' }) {
  return (
    <div className={`mb-8 ${className}`}>
      <h2 className="text-lg font-semibold text-gray-900 dark:text-white mb-4">{title}</h2>
      {children}
    </div>
  );
}

export function MetricSubsection({ title, children, className = '' }) {
  return (
    <div className={`mb-6 ${className}`}>
      <h3 className="text-md font-medium text-gray-800 dark:text-gray-200 mb-3">{title}</h3>
      {children}
    </div>
  );
}

export function MetricGrid({ cols = 4, children }) {
  const colClasses = {
    2: 'grid-cols-1 sm:grid-cols-2',
    3: 'grid-cols-1 sm:grid-cols-2 md:grid-cols-3',
    4: 'grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4'
  };
  
  return (
    <div className={`grid ${colClasses[cols] || colClasses[4]} gap-4`}>
      {children}
    </div>
  );
}

